import React from "react";
import "./modalOverlay.css";

interface ModalOverlayProps {
  children: React.ReactNode;
  closeModal?: () => void;
  closePath?: string;
  className?: string;
}

const ModalOverlay = ({ children, closeModal, className }: ModalOverlayProps) => {
  return (
    <div className={`modal-overlay ${className}`}>
      <div
        className="centered-content"
        onClick={(event) => {
          if (event.target === event.currentTarget && closeModal) {
            closeModal();
          }
        }}
      >
        <div className="content-host">
          <div className="modal-overlay-content">{children}</div>
        </div>
      </div>
      <div className="dim-background"></div>
    </div>
  );
};

export default ModalOverlay;
